import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=38caa3cc&lang=pug&"
import script from "./MobileSidebar.vue?vue&type=script&lang=js&"
export * from "./MobileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports